module.exports = __webpack_public_path__ + "static/media/zheng2-1.50232c90.png";